<template>
  <div
    data-test="indexedPages"
    :class="{
      'is-blurred': loading,
      'is-invisible': loading && !supportsBlur
    }"
  >
    <div v-if="data">
      <h6>{{ $t('seo_service.sub_headings.your_website') }}</h6>
      <progress
        class="progress is-info is-medium"
        :value="data.value"
        :max="maxScore"
      >
        <span
          data-test="yourSite"
          class="text-in-bar"
        >{{ data.value }}
        </span>
      </progress>

      <br>
      <h6>{{ $t('seo_service.sub_headings.avg_competitor') }}</h6>
      <progress
        class="progress is-info is-medium"
        :value="data.competitor_avg"
        :max="maxScore"
      >
        <span
          data-test="competitorSite"
          class="text-in-bar"
        >{{ data.competitor_avg }}</span>
      </progress>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BaseIndexedPages',

  props: {
    data: {
      type: Object,
      default: () => ({
        value: 0,
        competitor_avg: 0
      })
    },
    loading: {
      type: Boolean,
      default: false
    },
    supportsBlur: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    maxScore () {
      // Calculate a max value for the chart by finding the next order of magnitude
      // higher than the highest value between the customer's value and their
      // average competitor's value
      const { value, competitor_avg: competitor } = this.data
      const highestValue = Math.ceil(Math.max(value, competitor) / 10) * 10
      const numOfZeroes = Math.ceil(Math.log(highestValue) / Math.LN10 - 0.000000001)
      return Math.pow(10, numOfZeroes)
    }
  }
}
</script>

<style scoped>

.text-in-bar {
  margin-left: 2px;
  font-size: 1.2em;
  position: absolute;
  color: #75da75;
  mix-blend-mode: luminosity;
}
</style>
